export default __webpack_public_path__ + "static/media/Target-Audience.9f4350a4.png";